module.exports = __webpack_public_path__ + "images/help/icon-twr61@2x-1c4fec720b1164d820d4708569a1fa31.png";